import { createStore, applyMiddleware, combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'

import storage from 'redux-persist/lib/storage/session'

import basico from './basico'
import admrh from './ADMRH'
import contabilidade from './contabilidade'
import materiais from './materiais'
import documentos from './documentos'
import planejamentoEstrategico from './planejamentoEstrategico'
import sistema from './store'

const persistConfig = {
    key: 'transparencia',
    storage,
}

const reducersCombinados = combineReducers({ basico, contabilidade, documentos, materiais, sistema, admrh, planejamentoEstrategico })

const persistedReducer = persistReducer(persistConfig, reducersCombinados)

const store = createStore(persistedReducer, applyMiddleware(thunk))
const persistor = persistStore(store)

export { store, persistor }
